import axios from 'axios';
import apiService from '../apiService';

export default async function getFaceDetectionByGuestAndEventId(
  eventId = '',
  system = '',
  guestId = '',
) {
  try {
    const _ret = await axios({
      url: `${apiService.getUrl().faceRecognition}faceDetection/getFaceDetectionByGuestAndEventId?eventId=${eventId}&system=${system}&guestId=${guestId}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error getFaceDetectionByGuestAndEventId', error);
    throw error;
  }
}
